import { useCallback } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { pagesText } from '../../constants/pagesText';
import EnvironmentGuard from '../../components/EnvironmentGuard';
import Page from '../../components/Page';
import DevicesTable from './DevicesTable';
import WdacReadinessTable from './WdacReadinessTable';
import { PORTAL_ROUTE } from '../../constants/routes';
import useQueryData from '../../queries/useQueryData';
import { CUSTOMER_QUERY_KEY } from '../../constants/query';
import { companyNameSelector } from '../../selectors/customer';
import { useSearchParams } from 'react-router-dom';

const ALL_DEVICES_TAB = 'all';
const WDAC_READINESS_TAB = 'wdacReadiness';

const Devices = () => {
  const companyName = useQueryData(CUSTOMER_QUERY_KEY, companyNameSelector);
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab =
    searchParams.get('devicesTab') === WDAC_READINESS_TAB ? WDAC_READINESS_TAB : ALL_DEVICES_TAB;

  const onChangeTab = useCallback(
    (_, nextTab) => {
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set('devicesTab', nextTab);

      if (nextTab !== WDAC_READINESS_TAB) {
        nextParams.delete('readinessStatus');
      }

      setSearchParams(nextParams, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return (
    <Page
      title={pagesText.dashboard.title}
      breadcrumbs={[
        { label: companyName, route: `${PORTAL_ROUTE}/devices` },
        { label: pagesText.devices.breadcrumbs.pageName },
      ]}>
      <EnvironmentGuard>
        <Box sx={{ borderBottom: '1px solid #5B5B5B' }}>
          <Tabs
            value={activeTab}
            onChange={onChangeTab}
            sx={{
              mt: 2,
              '& .MuiTabs-indicator': {
                backgroundColor: '#87C8E0',
                height: 3,
              },
            }}>
            <Tab
              label="ALL DEVICES"
              value={ALL_DEVICES_TAB}
              sx={{
                color: '#DDDDDD',
                textTransform: 'none',
                '&.Mui-selected': { color: '#87C8E0' },
              }}
            />
            <Tab
              label="WDAC READINESS"
              value={WDAC_READINESS_TAB}
              sx={{
                color: '#DDDDDD',
                textTransform: 'none',
                '&.Mui-selected': { color: '#87C8E0' },
              }}
            />
          </Tabs>
        </Box>

        {activeTab === WDAC_READINESS_TAB ? <WdacReadinessTable /> : <DevicesTable />}
      </EnvironmentGuard>
    </Page>
  );
};

export default Devices;
